import VehicleInfoModal from './vehicle-info-modal.vue'
export default VehicleInfoModal
